import React from 'react'
import './Notification.css'
import Header from '../components/Header'

const NOTIFICATIONS = [
  {
    id: 1,
    message: 'John Doe registered for the 06:00 AM slot at Powerhouse Gym',
    type: 'booking',
    icon: '📅',
    profileImg: 'https://randomuser.me/api/portraits/men/1.jpg',
    time: '2 minutes ago',
  },
  {
    id: 2,
    message: 'Jane Smith purchased a yearly subscription at Powerhouse Gym',
    type: 'payment',
    icon: '💳',
    profileImg: 'https://randomuser.me/api/portraits/women/1.jpg',
    time: '15 minutes ago',
  },
  {
    id: 3,
    message: 'Alex Johnson registered for the 08:00 AM slot at GymX',
    type: 'booking',
    icon: '📅',
    profileImg: 'https://randomuser.me/api/portraits/men/2.jpg',
    time: '1 hour ago',
  },
  {
    id: 4,
    message: 'Emily Davis purchased a monthly subscription at Gold\'s Gym',
    type: 'payment',
    icon: '💳',
    profileImg: 'https://randomuser.me/api/portraits/women/2.jpg',
    time: '3 hours ago',
  },
]

const TYPE_COLOR = {
  booking: { bg: 'rgba(59,130,246,0.12)', color: '#60a5fa' },
  payment: { bg: 'rgba(16,185,129,0.12)', color: '#34d399' },
}

const Notifications = () => {
  return (
    <div className="notif-page">
      <Header />
      <div className="notif-content">
        <div className="notif-page-header">
          <h1 className="notif-title">Notifications</h1>
          <p className="notif-sub">{NOTIFICATIONS.length} recent updates</p>
        </div>

        <div className="notif-list">
          {NOTIFICATIONS.map(notif => {
            const typeStyle = TYPE_COLOR[notif.type] || TYPE_COLOR.booking
            return (
              <div className="notif-item" key={notif.id}>
                <img src={notif.profileImg} alt="" className="notif-avatar" />
                <div className="notif-body">
                  <p className="notif-message">{notif.message}</p>
                  <span className="notif-time">{notif.time}</span>
                </div>
                <span className="notif-badge" style={{ background: typeStyle.bg, color: typeStyle.color }}>
                  {notif.icon}
                </span>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Notifications
